var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 60,
    viewBox: "0 0 44 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M36 39.5C37.1 39.5 38 38.6 38 37.5H34C34 38.6 34.89 39.5 36 39.5ZM42 33.5V28.5C42 25.43 40.36 22.86 37.5 22.18V21.5C37.5 20.67 36.83 20 36 20C35.17 20 34.5 20.67 34.5 21.5V22.18C31.63 22.86 30 25.42 30 28.5V33.5L28 35.5V36.5H44V35.5L42 33.5Z",
    fill: "#071E26"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderNotification);
export default __webpack_public_path__ + "static/media/header_notification.96a04b22.svg";
export { ForwardRef as ReactComponent };